export default {
  errorsRootKey: 'invoice/customers',
  resource: 'invoice/customers',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}
